import { W as WuiListItem$1, d as defineCustomElement$1 } from './list-item.js';

const WuiListItem = WuiListItem$1;
const defineCustomElement = defineCustomElement$1;

export { WuiListItem, defineCustomElement };

//# sourceMappingURL=wui-list-item.js.map